<template>
<b-row>
	<b-col cols="12">
	    <otif-table
            class="ot-table-high-density"
	        :rows="events"
	        :columns="columns"
	        :globalActions="globalActions"
	        :actions="actions"
	        :editActions="actions"
	        :sortable=true>
	    </otif-table>
	</b-col>
    
</b-row>

</template>

<script>

//import ActivityInfo from './ActivityInfo.vue';
import PageIntro from './PageIntro.vue';

import CollectionTable from '@/components/CollectionTable.vue';
import EventNameColumn from './EventNameColumn.vue'

export default {

    data() {
        return {
            
               // events:[],
            actions: [],
            globalActions: [],
            columns: [{
                    name: 'severity',
                    label: 'Level',
                    displayComponent: EventNameColumn,
                    sortable:true
                },{
                    name: 'description',
                    label: 'Events',
                },{
                    name: 'timeStamp',
                    label: 'Date'
                },{
                    name: 'componentId',
                    label: 'Component'
                },{
                    name: 'groupName',
                    label: 'Project'
                },{
                    name: 'jobId',
                    label: 'job'
                }
            ]              
        }
    },

    computed: {

        events() {
            return this.$store.state.components.events
        },        

        information(){
            return "Event Information"
        },
        
    },
    methods:{
        
    },
    components: {
        //ActivityInfo,
        PageIntro,
        CollectionTable,
        EventNameColumn
    }
}
</script>
